/**
 * Plays a short two-tone notification sound using Web Audio API.
 * No external assets required, completely silent fallback if AudioContext
 * is unavailable (older browsers, blocked autoplay, etc.).
 */
export function playNotificationSound({ pitch = 'high' } = {}) {
  try {
    const Ctx = window.AudioContext || window.webkitAudioContext;
    if (!Ctx) return;
    const ctx = new Ctx();
    const playTone = (freq, start, dur, vol = 0.15) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.type = 'sine';
      osc.frequency.value = freq;
      gain.gain.setValueAtTime(vol, ctx.currentTime + start);
      gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + start + dur);
      osc.connect(gain).connect(ctx.destination);
      osc.start(ctx.currentTime + start);
      osc.stop(ctx.currentTime + start + dur);
    };
    if (pitch === 'low') {
      // Soft chat-message tone
      playTone(660, 0, 0.10, 0.12);
      playTone(880, 0.08, 0.12, 0.10);
    } else {
      playTone(880, 0, 0.12);
      playTone(1100, 0.1, 0.15);
    }
  } catch (e) { /* silent */ }
}
